// extracted by mini-css-extract-plugin
export default {"imageWrapper":"LN-z","twoColumnImage":"MN-z"};